var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgYellowMoodAgentIcon = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1603_9523",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1603_9523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7296 14.2298C21.4356 14.5238 21.091 14.6667 20.6665 14.6667C20.242 14.6667 19.8974 14.5238 19.6034 14.2298C19.3093 13.9357 19.1665 13.5911 19.1665 13.1667C19.1665 12.7422 19.3093 12.3976 19.6034 12.1036C19.8974 11.8095 20.242 11.6667 20.6665 11.6667C21.091 11.6667 21.4356 11.8095 21.7296 12.1036C22.0237 12.3976 22.1665 12.7422 22.1665 13.1667C22.1665 13.5911 22.0237 13.9357 21.7296 14.2298ZM12.3963 14.2298C12.1022 14.5238 11.7576 14.6667 11.3332 14.6667C10.9087 14.6667 10.5641 14.5238 10.2701 14.2298C9.976 13.9357 9.83317 13.5911 9.83317 13.1667C9.83317 12.7422 9.976 12.3976 10.2701 12.1036C10.5641 11.8095 10.9087 11.6667 11.3332 11.6667C11.7576 11.6667 12.1022 11.8095 12.3963 12.1036C12.6903 12.3976 12.8332 12.7422 12.8332 13.1667C12.8332 13.5911 12.6903 13.9357 12.3963 14.2298ZM15.9998 29.3333C14.2205 29.3333 12.5549 28.9961 10.9979 28.3243C9.43131 27.6482 8.07354 26.7333 6.92006 25.5798C5.76657 24.4263 4.8516 23.0685 4.17559 21.5019C3.50376 19.945 3.1665 18.2794 3.1665 16.5C3.1665 14.7206 3.50376 13.055 4.17559 11.4981C4.8516 9.93148 5.76657 8.57371 6.92006 7.42023C8.07354 6.26674 9.43131 5.35176 10.9979 4.67576C12.5549 4.00393 14.2205 3.66667 15.9998 3.66667C17.7792 3.66667 19.4448 4.00393 21.0017 4.67576C22.5684 5.35176 23.9261 6.26674 25.0796 7.42023C26.2331 8.57371 27.1481 9.93148 27.8241 11.4981C28.4959 13.055 28.8332 14.7206 28.8332 16.5C28.8332 18.2794 28.4959 19.945 27.8241 21.5019C27.1481 23.0685 26.2331 24.4263 25.0796 25.5798C23.9261 26.7333 22.5684 27.6482 21.0017 28.3243C19.4448 28.9961 17.7792 29.3333 15.9998 29.3333ZM15.9998 27.6667C19.1074 27.6667 21.7577 26.5826 23.9201 24.4202C26.0825 22.2578 27.1665 19.6076 27.1665 16.5C27.1665 13.3924 26.0825 10.7422 23.9201 8.57979C21.7577 6.41739 19.1074 5.33334 15.9998 5.33334C12.8923 5.33334 10.242 6.41739 8.07962 8.57979C5.91722 10.7422 4.83317 13.3924 4.83317 16.5C4.83317 19.6076 5.91722 22.2578 8.07962 24.4202C10.242 26.5826 12.8923 27.6667 15.9998 27.6667Z",
    fill: "#F2BD00",
    stroke: "#F2BD00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.3335,
    y: 19.1667,
    width: 13.3333,
    height: 2.66667,
    rx: 1.33333,
    fill: "#F2BD00"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYellowMoodAgentIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/yellow-mood-agent-icon.397cc86c.svg";
export { ForwardRef as ReactComponent };